export default {
    async tryCatch(
        promise,
    ) {
        try {
            const res = await promise;
            return { res, error: null };
        } catch (error) {
            return { res: null, error: error };
        }
    }
}